import * as React from 'react';
import { st, classes } from './Input.st.css';
import './Input.responsive.st.css';
import Text from '../Text';
import { AlertCircleBold, AlertCircleBoldSmall, WarningCircleBold, WarningCircleBoldSmall, SuccessBoldSmall, ConfirmCircleBold, } from '../../icons';
import { useEffect } from 'react';
import { dataHooks } from './constants';
import { BaseUiNextContext, } from '../../utils/BaseUINextContext';
import { useTooltip } from '../Tooltip/hooks/useTooltip';
const _getIcon = (size, status, isResponsive) => {
    let icon;
    switch (`${size}-${status}`) {
        case 'large-error': // error
            icon = isResponsive ? React.createElement(AlertCircleBoldSmall, null) : React.createElement(AlertCircleBold, null);
            break;
        case 'medium-error':
        case 'small-error':
            icon = React.createElement(AlertCircleBoldSmall, null);
            break;
        case 'large-warning': // warning
            icon = isResponsive ? React.createElement(WarningCircleBoldSmall, null) : React.createElement(WarningCircleBold, null);
            break;
        case 'medium-warning':
        case 'small-warning':
            icon = React.createElement(WarningCircleBoldSmall, null);
            break;
        case 'medium-success': // success
        case 'small-success':
            icon = React.createElement(SuccessBoldSmall, null);
            break;
        default:
            icon = React.createElement(ConfirmCircleBold, null);
            icon = isResponsive ? React.createElement(SuccessBoldSmall, null) : React.createElement(ConfirmCircleBold, null);
    }
    return icon;
};
const Input = React.forwardRef(({ dataHook, className, value, placeholder, onChange, disabled = false, inputProps, size = 'large', status, prefix, suffix, statusContent, readOnly = false, ...rest }, forwardedRef) => {
    const inputRef = React.useRef(null);
    const { getTriggerProps, renderTooltip } = useTooltip({ forwardedRef });
    const _onChange = (event) => {
        // TODO: This conditions is relevant for testing using unidriver. char limitation works if inputProps.maxLength is passed to the component
        // Can be removed if unidriver testing is fixed
        if (inputProps?.maxLength &&
            event.target.value.length > inputProps.maxLength) {
            return;
        }
        onChange(event.target.value);
    };
    // Loses focus on esc click
    useEffect(() => {
        const keyDownHandler = (event) => {
            if (event.key === 'Escape') {
                document.activeElement.blur();
            }
        };
        document.addEventListener('keydown', keyDownHandler);
        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    });
    const context = React.useContext(BaseUiNextContext);
    const isResponsive = context.theme === 'responsive';
    return (React.createElement("div", { ...rest, "data-hook": dataHook, ...(status ? getTriggerProps() : { ref: forwardedRef }), className: st(classes.root, { disabled, size, status }, className), onClick: () => inputRef?.current?.focus() },
        prefix &&
            (typeof prefix === 'string' ? (React.createElement(Text, { className: classes.prefix, size: isResponsive ? 'small' : 'tiny', dataHook: dataHooks.prefix, weight: isResponsive ? 'thin' : 'normal' }, prefix)) : (React.createElement("div", { className: classes.prefixNode, "data-hook": dataHooks.prefix }, prefix))),
        React.createElement("input", { ...inputProps, value: value, className: classes.input, placeholder: placeholder, onChange: _onChange, disabled: disabled, readOnly: readOnly, "data-hook": dataHooks.input, ref: inputRef }),
        suffix &&
            (typeof suffix === 'string' ? (React.createElement(Text, { className: classes.suffix, size: isResponsive ? 'small' : 'tiny', dataHook: dataHooks.suffix, weight: isResponsive ? 'thin' : 'normal' }, suffix)) : (React.createElement("div", { className: classes.suffixNode, "data-hook": dataHooks.suffix }, suffix))),
        status &&
            renderTooltip(React.createElement("div", { className: classes.icon, "data-hook": dataHooks.statusIcon }, _getIcon(size, status, isResponsive)), statusContent)));
});
export default Input;
//# sourceMappingURL=Input.js.map